// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y7Nx7Cr1TtmW4ASo0VY5,
.y7Nx7Cr1TtmW4ASo0VY5 p,
.y7Nx7Cr1TtmW4ASo0VY5 span,
.y7Nx7Cr1TtmW4ASo0VY5 div,
.y7Nx7Cr1TtmW4ASo0VY5 label,
.y7Nx7Cr1TtmW4ASo0VY5 td,
.y7Nx7Cr1TtmW4ASo0VY5 th,
.y7Nx7Cr1TtmW4ASo0VY5 input,
.y7Nx7Cr1TtmW4ASo0VY5 textarea,
.y7Nx7Cr1TtmW4ASo0VY5 select {
  font-family: 'Titillium Web', sans-serif !important;
}

.jvBE8mURC_IdWYLHnXU4 {
    display: inline-block !important;
    height: auto !important;
    opacity: 1 !important;
    position: relative !important;
    pointer-events: auto !important;
    font-size: 14px !important;
    height: 26px !important;
    margin-bottom: 0 !important;
    border: none !important;
    border-bottom: 1px solid #9e9e9e !important;
    padding: 0 !important;
}

.HQ8wAsiqfIbHQEBl8ynE{
    font-size: 14px !important;
    height: 26px !important;
    margin-bottom: 0 !important;
}

.GXlT2h5vFwCjkhqZ1txQ {
    font-weight: bold !important;
}

._2Ox8a9tL99eN3cfadyF {
    font-style: italic !important;
}

.HHT3NdpLsjB3wDdgFcyp {
    font-size: 15px;
}

.xB5kMpnFA4CZPws0ZB3v {
    font-size: 13px;
}

.Yd0yoKgLSxLwynjd1S4M {
    font-size: 14px;
}

.HHT3NdpLsjB3wDdgFcyp {
    font-size: 15px;
}

.ugBt4MGiOb2DFXqpRLyF {
    font-size: 16px;
}

.bw0PA147IW7666x4KZfn {
    font-size: 18px;
}

.De666OCGlMFmMIGbct1l {
    font-size: 20px;
}

.HsXLb9fWOQc7h8XdKMt9 {
    font-size: 22px;
}

.tsX3cXEfxB9qqcyeccJl{
    font-size: 24px;
}

.X_0vxuuWb7FuISJr5ta9 {
    background-color: var(--main-color-first) !important;
}

.xOz6IP2OVhytb_BEd_pa {
    color: var(--main-color-first) !important;
}

.Yssvoyks3Tt_18WYq6Bq {
    color: var(--main-color-text-first) !important;
}

.NBhOJ47WfZNMFovOLBIi {
    margin: 0 !important;
    padding: 0 !important;
}




.ESsTQs0NRD0m9VcdjFKY, .iSN2Ll6PzRlwvLTP3PoR{
    text-align: center;
    display: inline-block;
    width:100%;
}

.ESsTQs0NRD0m9VcdjFKY button {
    margin: 0 10px;
}

.iSN2Ll6PzRlwvLTP3PoR button {
    margin: 0 5px;
}

.UFyv3GYPGJ9NWKpEgM5D {
    display: flex;
    align-items: center;
    gap: 4px; /* espace entre les inputs */
}

.UFyv3GYPGJ9NWKpEgM5D input[type="color"]{
    width: 25px;
    padding: 0px;
    border:none;
}

.Ge_14J3gaFWkhY7L8578 input{
    height: 20px !important;
    font-size: 12px !important;
}

.B532rq_23Pe9TF1PjzKH{
    margin-right: 10px !important;
}

.oeb38Hm18558EJlE2mci{
    margin-left: 10px !important;
    cursor: pointer;
}

.WESAR4jMpRrAWng01XH5{
    margin-bottom: 10px !important;
    text-transform: uppercase;
}

.RbcSiMrUexvaQLlCo3z8{
    margin: 0px 5px !important;
}

.SLQOkMmQUALpvE7my4r6 {
    display: inline-block;
    cursor: pointer;
}

.pvTKSJb26xmQWrNB4Fix {
    display: block;
    width: 100%;
    cursor: pointer;
}

.mBWaK0cEyX3MFXZ9pmmf {
    position: absolute;
    background: #3f3f3f;
    color: white;
    padding: 10px;
    border-radius: 4px;
    font-size: 15px;
    z-index: 99999999;
    width: max-content;
    opacity: 1;
    text-align: left;
    white-space: pre-line;
    line-height: 0.7;
}

.iQAPU9z2gCIQaymR3Y39 {
    display: flex;
    align-items: center;
    gap: 8px;
}

.ozZgKYALSYKMZaU6MqxP{
    width: 50vw;
    height: 50vh;
}

.GCkwjtQqCSEro4HTqmTm{
    position: absolute;
    background-color: rgba(255,255,255,0.1);
    cursor: not-allowed;
    z-index: 10;
    left: 0;
    width: 100%;
    height: 98vh;
}

.n0NMaGXltW_TGBFncncp{
    width: 100%;
    margin-top: 25px;
    font-size: inherit !important;
}

.n0NMaGXltW_TGBFncncp input{
    font-size: inherit !important;
}

.CV7YlqDceeJw5hSAPGeu{    
    font-size: 13px;
    font-style: italic;
}

/* Tabs as buttons */
.Qu8WSNbuPEA3VUE0KoTp{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.r1Oj_jrfoXY36ogdYUaX{
    padding: 8px 12px;
    border-radius: 4px;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: opacity 0.2s ease;
}

.y3_2JBurG6RHs77ajIZj{
    background-color: var(--main-color-first) !important;
    color: #ffffff !important;
}

.reQwrlnWK8rXoFECVyHx{
    background-color: #e7e7e7 !important;
    color: #373737 !important;
    border: 1px dotted grey;
}

/* Formulaire de marqueur avec hauteur fixe et scroll */
.CKnnjqHED3JMrngXKPOF {
    height: 100%; /* Hauteur ajustée pour laisser de la place aux boutons */
    overflow-y: auto;
    position: relative;
    padding: 0px 11px;
}

.CjdCaJHB4l96gjlh0z1V {
    padding: 15px;
    background-color: whitesmoke;
    border-radius: 10px;
    border: 1px solid #bdbdbd;
    margin-bottom: 8px;
}

.CjdCaJHB4l96gjlh0z1V input{
    font-size: 14px !important;
    height: 26px !important;
    margin-bottom: 0 !important;
}

.UatwlZ13jcublbROtyUH {
    position: sticky;
    bottom: 0;
    padding: 10px;
    text-align: center;
}

.UatwlZ13jcublbROtyUH button {
    width: 40% !important;
    margin: 0 5px !important;
}

/* Barre d'outils style Google */
.JMS38vIp_srUriL6JFhL {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 8px 16px;
}

.JMS38vIp_srUriL6JFhL button {
    width: 50px !important;
    height: 40px !important;
    border-radius: 8px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 !important;
    transition: all 0.2s ease !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12) !important;
}

.JMS38vIp_srUriL6JFhL button:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15) !important;
}

.JMS38vIp_srUriL6JFhL button i {
    font-size: 16px !important;
}

/* Styles pour les statistiques d'entités */
.agXHbu9YBIQe6oJKDRnk {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 0;
}

.agXHbu9YBIQe6oJKDRnk .Y043oiZjvuQ3bcKEQapQ {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    padding: 6px 10px;
    margin: 0 4px;
    border-radius: 4px;
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
}

/* Styles pour le texte enrichi */
.JZ2x49zwDi0LQQcTEfzq {
    min-height: 50px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
}

.JZ2x49zwDi0LQQcTEfzq p {
    margin: 0 0 8px 0;
}

.JZ2x49zwDi0LQQcTEfzq strong {
    font-weight: bold;
}

.JZ2x49zwDi0LQQcTEfzq em {
    font-style: italic;
}

.JZ2x49zwDi0LQQcTEfzq ins {
    text-decoration: underline;
}

.JZ2x49zwDi0LQQcTEfzq ul {
    padding-left: 20px;
    margin: 0 0 8px 0;
    list-style-type: disc !important;
}

.JZ2x49zwDi0LQQcTEfzq li {
    margin-bottom: 4px;
    list-style-type: disc !important;
}

.JZ2x49zwDi0LQQcTEfzq a {
    color: blue;
    text-decoration: underline;
}

/* globale pour cibler le popup du lien dans react-draft-wysiwyg */
.rdw-link-modal-target-option {
    display: none !important;
}

.dropify-wrapper input {
    height: 100% !important;
}

.yOgrXbDF16030i3UyGml{
    background: #FFFFFF !important;
}

.XcTLaoAiHsKNYrHzdS3w{
    position: absolute;
    top: 83px;
    height: 85vh;
    width: 100%;
    background-color: rgba(255,255,255,0.1);
    z-index: 1999;
}

.TulWyYUEWN_9RjOIQsjB{
    width: 100%!important;
    height: 400px;
    border: 1px #9a9a9a solid;
}

.LDD2Q5hgTlaPmQSzlqQ3 {
    text-transform: uppercase;
}

.wNEAJU9U4f26T_Ep3ahF {
    margin-bottom: 10px;
}

.qrRmtv93WjI2TUyBb9Sc {
    max-height: 80vh;
    overflow-x: hidden;
    overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/component/generale.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE,mDAAmD;AACrD;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;;;;AAKA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAE,4BAA4B;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;AACjC;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA,uDAAuD;AACvD;IACI,YAAY,EAAE,yDAAyD;IACvE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,oBAAoB;IACpB,oCAAoC;IACpC,iDAAiD;AACrD;;AAEA;IACI,sCAAsC;IACtC,iDAAiD;AACrD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA,kEAAkE;AAClE;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".familyFont,\r\n.familyFont p,\r\n.familyFont span,\r\n.familyFont div,\r\n.familyFont label,\r\n.familyFont td,\r\n.familyFont th,\r\n.familyFont input,\r\n.familyFont textarea,\r\n.familyFont select {\r\n  font-family: 'Titillium Web', sans-serif !important;\r\n}\r\n\r\n.selectCol {\r\n    display: inline-block !important;\r\n    height: auto !important;\r\n    opacity: 1 !important;\r\n    position: relative !important;\r\n    pointer-events: auto !important;\r\n    font-size: 14px !important;\r\n    height: 26px !important;\r\n    margin-bottom: 0 !important;\r\n    border: none !important;\r\n    border-bottom: 1px solid #9e9e9e !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n.inputtCol{\r\n    font-size: 14px !important;\r\n    height: 26px !important;\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n.bold {\r\n    font-weight: bold !important;\r\n}\r\n\r\n.italic {\r\n    font-style: italic !important;\r\n}\r\n\r\n.fontSize15 {\r\n    font-size: 15px;\r\n}\r\n\r\n.fontSize13 {\r\n    font-size: 13px;\r\n}\r\n\r\n.fontSize14 {\r\n    font-size: 14px;\r\n}\r\n\r\n.fontSize15 {\r\n    font-size: 15px;\r\n}\r\n\r\n.fontSize16 {\r\n    font-size: 16px;\r\n}\r\n\r\n.fontSize18 {\r\n    font-size: 18px;\r\n}\r\n\r\n.fontSize20 {\r\n    font-size: 20px;\r\n}\r\n\r\n.fontSize22 {\r\n    font-size: 22px;\r\n}\r\n\r\n.fontSize24{\r\n    font-size: 24px;\r\n}\r\n\r\n.bgcolorfirst {\r\n    background-color: var(--main-color-first) !important;\r\n}\r\n\r\n.bgcolorfirsttext {\r\n    color: var(--main-color-first) !important;\r\n}\r\n\r\n.maincolorfirsttext {\r\n    color: var(--main-color-text-first) !important;\r\n}\r\n\r\n.noMargin {\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n\r\n\r\n\r\n.buttonfooter, .buttonfooterfrm{\r\n    text-align: center;\r\n    display: inline-block;\r\n    width:100%;\r\n}\r\n\r\n.buttonfooter button {\r\n    margin: 0 10px;\r\n}\r\n\r\n.buttonfooterfrm button {\r\n    margin: 0 5px;\r\n}\r\n\r\n.pickctn {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px; /* espace entre les inputs */\r\n}\r\n\r\n.pickctn input[type=\"color\"]{\r\n    width: 25px;\r\n    padding: 0px;\r\n    border:none;\r\n}\r\n\r\n.ctnFrmedi input{\r\n    height: 20px !important;\r\n    font-size: 12px !important;\r\n}\r\n\r\n.icomargin{\r\n    margin-right: 10px !important;\r\n}\r\n\r\n.icomarginObserv{\r\n    margin-left: 10px !important;\r\n    cursor: pointer;\r\n}\r\n\r\n.titleedsection{\r\n    margin-bottom: 10px !important;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.marginlr{\r\n    margin: 0px 5px !important;\r\n}\r\n\r\n.tooltipWrapper {\r\n    display: inline-block;\r\n    cursor: pointer;\r\n}\r\n\r\n.tooltipWrapperFull {\r\n    display: block;\r\n    width: 100%;\r\n    cursor: pointer;\r\n}\r\n\r\n.tooltipBubble {\r\n    position: absolute;\r\n    background: #3f3f3f;\r\n    color: white;\r\n    padding: 10px;\r\n    border-radius: 4px;\r\n    font-size: 15px;\r\n    z-index: 99999999;\r\n    width: max-content;\r\n    opacity: 1;\r\n    text-align: left;\r\n    white-space: pre-line;\r\n    line-height: 0.7;\r\n}\r\n\r\n.ctnswitch {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.cnttblshared{\r\n    width: 50vw;\r\n    height: 50vh;\r\n}\r\n\r\n.ctnDisabled{\r\n    position: absolute;\r\n    background-color: rgba(255,255,255,0.1);\r\n    cursor: not-allowed;\r\n    z-index: 10;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 98vh;\r\n}\r\n\r\n.ctnlistfichier{\r\n    width: 100%;\r\n    margin-top: 25px;\r\n    font-size: inherit !important;\r\n}\r\n\r\n.ctnlistfichier input{\r\n    font-size: inherit !important;\r\n}\r\n\r\n.sectionTitle{    \r\n    font-size: 13px;\r\n    font-style: italic;\r\n}\r\n\r\n/* Tabs as buttons */\r\n.tabsCtn{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.tabBtn{\r\n    padding: 8px 12px;\r\n    border-radius: 4px;\r\n    text-decoration: none;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    transition: opacity 0.2s ease;\r\n}\r\n\r\n.tabBtnActive{\r\n    background-color: var(--main-color-first) !important;\r\n    color: #ffffff !important;\r\n}\r\n\r\n.tabBtnInactive{\r\n    background-color: #e7e7e7 !important;\r\n    color: #373737 !important;\r\n    border: 1px dotted grey;\r\n}\r\n\r\n/* Formulaire de marqueur avec hauteur fixe et scroll */\r\n.editFormContainer {\r\n    height: 100%; /* Hauteur ajustée pour laisser de la place aux boutons */\r\n    overflow-y: auto;\r\n    position: relative;\r\n    padding: 0px 11px;\r\n}\r\n\r\n.editFormSection {\r\n    padding: 15px;\r\n    background-color: whitesmoke;\r\n    border-radius: 10px;\r\n    border: 1px solid #bdbdbd;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.editFormSection input{\r\n    font-size: 14px !important;\r\n    height: 26px !important;\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n.editFormButtons {\r\n    position: sticky;\r\n    bottom: 0;\r\n    padding: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.editFormButtons button {\r\n    width: 40% !important;\r\n    margin: 0 5px !important;\r\n}\r\n\r\n/* Barre d'outils style Google */\r\n.buttonheaderfrm {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 12px;\r\n    padding: 8px 16px;\r\n}\r\n\r\n.buttonheaderfrm button {\r\n    width: 50px !important;\r\n    height: 40px !important;\r\n    border-radius: 8px !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    margin: 0 !important;\r\n    transition: all 0.2s ease !important;\r\n    box-shadow: 0 1px 3px rgba(0,0,0,0.12) !important;\r\n}\r\n\r\n.buttonheaderfrm button:hover {\r\n    transform: translateY(-1px) !important;\r\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15) !important;\r\n}\r\n\r\n.buttonheaderfrm button i {\r\n    font-size: 16px !important;\r\n}\r\n\r\n/* Styles pour les statistiques d'entités */\r\n.entityStatsContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n    padding: 8px 0;\r\n}\r\n\r\n.entityStatsContainer .contenuInfo {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 40px;\r\n    padding: 6px 10px;\r\n    margin: 0 4px;\r\n    border-radius: 4px;\r\n    background-color: #f5f5f5;\r\n    border: 1px solid #e0e0e0;\r\n}\r\n\r\n/* Styles pour le texte enrichi */\r\n.observationPreview {\r\n    min-height: 50px;\r\n    padding: 5px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n.observationPreview p {\r\n    margin: 0 0 8px 0;\r\n}\r\n\r\n.observationPreview strong {\r\n    font-weight: bold;\r\n}\r\n\r\n.observationPreview em {\r\n    font-style: italic;\r\n}\r\n\r\n.observationPreview ins {\r\n    text-decoration: underline;\r\n}\r\n\r\n.observationPreview ul {\r\n    padding-left: 20px;\r\n    margin: 0 0 8px 0;\r\n    list-style-type: disc !important;\r\n}\r\n\r\n.observationPreview li {\r\n    margin-bottom: 4px;\r\n    list-style-type: disc !important;\r\n}\r\n\r\n.observationPreview a {\r\n    color: blue;\r\n    text-decoration: underline;\r\n}\r\n\r\n/* globale pour cibler le popup du lien dans react-draft-wysiwyg */\r\n:global(.rdw-link-modal-target-option) {\r\n    display: none !important;\r\n}\r\n\r\n:global(.dropify-wrapper input) {\r\n    height: 100% !important;\r\n}\r\n\r\n.genbackground{\r\n    background: #FFFFFF !important;\r\n}\r\n\r\n.modalsetstyle{\r\n    position: absolute;\r\n    top: 83px;\r\n    height: 85vh;\r\n    width: 100%;\r\n    background-color: rgba(255,255,255,0.1);\r\n    z-index: 1999;\r\n}\r\n\r\n.modal_collection_map_modal{\r\n    width: 100%!important;\r\n    height: 400px;\r\n    border: 1px #9a9a9a solid;\r\n}\r\n\r\n.uppercase {\r\n    text-transform: uppercase;\r\n}\r\n\r\n.interbottom {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.modalCollFrm {\r\n    max-height: 80vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"familyFont": `y7Nx7Cr1TtmW4ASo0VY5`,
	"selectCol": `jvBE8mURC_IdWYLHnXU4`,
	"inputtCol": `HQ8wAsiqfIbHQEBl8ynE`,
	"bold": `GXlT2h5vFwCjkhqZ1txQ`,
	"italic": `_2Ox8a9tL99eN3cfadyF`,
	"fontSize15": `HHT3NdpLsjB3wDdgFcyp`,
	"fontSize13": `xB5kMpnFA4CZPws0ZB3v`,
	"fontSize14": `Yd0yoKgLSxLwynjd1S4M`,
	"fontSize16": `ugBt4MGiOb2DFXqpRLyF`,
	"fontSize18": `bw0PA147IW7666x4KZfn`,
	"fontSize20": `De666OCGlMFmMIGbct1l`,
	"fontSize22": `HsXLb9fWOQc7h8XdKMt9`,
	"fontSize24": `tsX3cXEfxB9qqcyeccJl`,
	"bgcolorfirst": `X_0vxuuWb7FuISJr5ta9`,
	"bgcolorfirsttext": `xOz6IP2OVhytb_BEd_pa`,
	"maincolorfirsttext": `Yssvoyks3Tt_18WYq6Bq`,
	"noMargin": `NBhOJ47WfZNMFovOLBIi`,
	"buttonfooter": `ESsTQs0NRD0m9VcdjFKY`,
	"buttonfooterfrm": `iSN2Ll6PzRlwvLTP3PoR`,
	"pickctn": `UFyv3GYPGJ9NWKpEgM5D`,
	"ctnFrmedi": `Ge_14J3gaFWkhY7L8578`,
	"icomargin": `B532rq_23Pe9TF1PjzKH`,
	"icomarginObserv": `oeb38Hm18558EJlE2mci`,
	"titleedsection": `WESAR4jMpRrAWng01XH5`,
	"marginlr": `RbcSiMrUexvaQLlCo3z8`,
	"tooltipWrapper": `SLQOkMmQUALpvE7my4r6`,
	"tooltipWrapperFull": `pvTKSJb26xmQWrNB4Fix`,
	"tooltipBubble": `mBWaK0cEyX3MFXZ9pmmf`,
	"ctnswitch": `iQAPU9z2gCIQaymR3Y39`,
	"cnttblshared": `ozZgKYALSYKMZaU6MqxP`,
	"ctnDisabled": `GCkwjtQqCSEro4HTqmTm`,
	"ctnlistfichier": `n0NMaGXltW_TGBFncncp`,
	"sectionTitle": `CV7YlqDceeJw5hSAPGeu`,
	"tabsCtn": `Qu8WSNbuPEA3VUE0KoTp`,
	"tabBtn": `r1Oj_jrfoXY36ogdYUaX`,
	"tabBtnActive": `y3_2JBurG6RHs77ajIZj`,
	"tabBtnInactive": `reQwrlnWK8rXoFECVyHx`,
	"editFormContainer": `CKnnjqHED3JMrngXKPOF`,
	"editFormSection": `CjdCaJHB4l96gjlh0z1V`,
	"editFormButtons": `UatwlZ13jcublbROtyUH`,
	"buttonheaderfrm": `JMS38vIp_srUriL6JFhL`,
	"entityStatsContainer": `agXHbu9YBIQe6oJKDRnk`,
	"contenuInfo": `Y043oiZjvuQ3bcKEQapQ`,
	"observationPreview": `JZ2x49zwDi0LQQcTEfzq`,
	"genbackground": `yOgrXbDF16030i3UyGml`,
	"modalsetstyle": `XcTLaoAiHsKNYrHzdS3w`,
	"modal_collection_map_modal": `TulWyYUEWN_9RjOIQsjB`,
	"uppercase": `LDD2Q5hgTlaPmQSzlqQ3`,
	"interbottom": `wNEAJU9U4f26T_Ep3ahF`,
	"modalCollFrm": `qrRmtv93WjI2TUyBb9Sc`
};
export default ___CSS_LOADER_EXPORT___;
